<template>
    <div class="order-details" id="subOutputRank-print1">
        <div class="loading" style="text-align: center">
            <Loading :isLoading="isLoading"></Loading>
        </div>
        <div class="layer_box" @click="isLayerShow" v-if="layerShow">
            <div class="layer">
                <div class="close"><i class="iconfont icon-close"></i></div>
                <div class="little">长隆度假区</div>
                <div class="title">酒店住客门票激活</div>
                <div class="content">凡购买长隆旗下酒店含门票套票产品的游客，可凭订单中所填写的入住人国内第二代居民身份证，提前在【长隆酒店住客门票激活平台】完成乐园门票的“人证合一”比对，成功后即可先到乐园游玩后到酒店办理入住，请游客前往酒店或园区按照现场工作人员的指引，扫描专属码进入平台进行人脸识别激活门票，如无法成功进行，请联系您的预订渠道。</div>
            </div>
        </div>
        <div class="order-details-in" v-if="!isLoading">
            <div class="left">
                <div class="state">
                    <div>
                    	<div class="to-print-btn" @click="printBtn" v-if="!isPrint">
                            <i class="iconfont icon-print"></i> 打印预订单
                        </div>
                        <!-- <div class="print-btn"  @click="routeToCus" v-if="OrderDetailsList.Status == 10||OrderDetailsList.Status == 27"> -->
                           <div class="to-customer-btn " @click="routeToCus" v-if="OrderDetailsList.Status>=10">
                           酒店入住单
                        </div>
                        <img :src="qr" alt="" class="logo-od-qr" />
                        <div class="logo">
                            <!-- <img :src="qr" alt="" class="qr"> -->
                            <img src="../../assets/img/cnbookinglog.png" height="39" width="100" style="margin-right: 10px"/>
                            <img src="../../assets/img/logo-cn.png" height="36" width="161"/></div>
                        </div>
                    <div class="link"></div>
                    <div class="info">

                        <div class="orderNo" style="display:flex">
                            <div class="icon-box" >
                                <i class="iconfont icon-yudingdan"></i>
                            </div>
                            <div >
                                <span class="til">订单号</span><br>
                                <span class="info">{{OrderDetailsList.OrderNO}}</span>
                            </div>
                        </div>
                        <div class="orderNo">
                            <span class="til">订单总价</span><br>
                            <span class="info">{{OrderDetailsList.Currency}}{{OrderDetailsList.TotalAmount}}</span>
                        </div>
                        <div class="order-state">
                            <span class="til">订单状态</span><br>
                            <span class="info" v-if="OrderDetailsList.Status == 0">无效单</span>
                            <span class="info" v-if="OrderDetailsList.Status == 2">已锁定</span>
                            <span class="info" v-if="OrderDetailsList.Status == 9">新单</span>
                            <span class="info" v-if="OrderDetailsList.Status == 8">取消单</span>
                            <span class="info" v-if="OrderDetailsList.Status == 27">可入住</span>
                            <span class="info" v-if="OrderDetailsList.Status == 10 &&  OrderDetailsList.SettlementType==1 && OrderDetailsList.NeedPay">以支付后订单状态为准</span>
                            <span class="info" v-else-if="OrderDetailsList.Status == 10">已确定</span>

                        </div>
                        <div class="pay-state">
                            <span class="til">支付状态</span><br>
                            <span class="info" v-if="OrderDetailsList.PaymentType==0">未支付 <span v-if="OrderDetailsList.NeedPay" class="go-pay" @click="routerBookComfirm(OrderDetailsList.OrderNO)">去支付</span></span>
                            <span class="info" v-if="OrderDetailsList.PaymentType==1">未支付 <span v-if="OrderDetailsList.NeedPay" class="go-pay" @click="routerBookComfirm(OrderDetailsList.OrderNO)">去支付</span></span>
                            <span class="info" v-if="OrderDetailsList.PaymentType==2">未支付 <span v-if="OrderDetailsList.NeedPay" class="go-pay" @click="routerBookComfirm(OrderDetailsList.OrderNO)">去支付</span></span>
                            <span class="info" v-if="OrderDetailsList.PaymentType==3">已支付 <span v-if="OrderDetailsList.NeedPay" class="go-pay" @click="routerBookComfirm(OrderDetailsList.OrderNO)">去支付</span></span>
                            <span class="info" v-if="OrderDetailsList.PaymentType==4">已退款 <span v-if="OrderDetailsList.NeedPay" class="go-pay" @click="routerBookComfirm(OrderDetailsList.OrderNO)">去支付</span></span>
                        </div>
                        <div class="orderNo" >
                            <span class="til">结算方式</span><br>
                            <span class="info" v-if="OrderDetailsList.SettlementType == 1">单单清</span>
                          <span class="info" v-if="OrderDetailsList.SettlementType == 7">预付款支付</span>
                            <span class="info" v-if="OrderDetailsList.SettlementType != 1&&OrderDetailsList.SettlementType != 7">信贷支付</span>
                        </div>
                        <div class="creat-order-date">
                            订单来源：{{OrderDetailsList.Source==0?'手机订房易':OrderDetailsList.Source==1?'PC 端订房易':OrderDetailsList.Source==2?'线下客服':OrderDetailsList.Source==3?'API':''}}<br>
                            下单时间：{{OrderDetailsList.BookingOn|dateLong}}
                        </div>
                    </div>
                </div>
                <div class="main">
                    <div class="about">
                        <div class="title">订单详情 <label v-if="OrderDetailsList&&OrderDetailsList.Guest.length>0&&OrderDetailsList.Guest[0].CardNumber&&OrderDetailsList.HotelID!=1378315" @click="isLayerShow" style="color:#00a0e9; padding-left: 10px;">为提升您的入园体验，请点击链接进行“人证合一”激活</label></div>
                        <table>
                            <tbody>
                            <tr>
                                <td>酒店名</td>
                                <td colspan="3">{{OrderDetailsList.HotelName}}</td>
                            </tr>
                            <tr>
                                <td>房型名</td>
                                <td>{{OrderDetailsList.RoomName}}</td>
                                <td>产品政策</td>
                                <td>{{OrderDetailsList.RPName}}</td>
                            </tr>
                            <tr>
                                <td>取消条款</td>
                                <td v-if="!IsCancel" style="color: #f63;">订单不可取消或更改</td>
                                <td v-if="IsCancel">最晚取消时间：{{OrderDetailsList.CancelDate|dateLong}} <span  @click="cancelOrder(OrderDetailsList.Token)" class="order-btn" style="margin-left: 40px;font-size: 16px" v-if="OrderDetailsList.CanCancel">去取消</span></td>
                                
                                <td>入离时间</td>
                                <td>{{OrderDetailsList.CheckInStr|dateToYMDline}} - {{OrderDetailsList.CheckOutStr|dateToYMDline}}</td>
                            </tr>
                            <tr>    
                                <td>入住人</td>
                                <td style="width: 40%;"><span style="display: inline-block;" v-for="(item,index) in OrderDetailsList.Guest">{{item.FirstName}}{{item.LastName}} <span v-if="item.CardNumber">( {{item.CardNumber}} )</span>  {{OrderDetailsList.Guest.length-1==index?'':'、'}}</span></td>
                                <td>国籍</td>
                                <td>{{OrderDetailsList.GuestNationality}}</td>
                            </tr>
                            <tr>
                                <td>特殊要求</td>
                                <td>{{OrderDetailsList.Remark!=''?OrderDetailsList.Remark:'无'}}</td>                            
                                <td>间数</td>
                                <td>{{OrderDetailsList.RoomCount}}</td>
                            </tr>
                            <tr v-if="OrderDetailsList.VoucherCodes&&OrderDetailsList.VoucherCodes.length>0">
                                <td>餐食码</td>
                                <td colspan="3"><span v-for="(item,index) in OrderDetailsList.VoucherCodes"> {{item}} {{OrderDetailsList.VoucherCodes.length-1==index?'':'、'}}</span></td>
                                <!---->
                            </tr>
                            <tr v-if="OrderDetailsList.SeasonCode">
                                <td>马戏场次</td>
                                <td colspan="3">{{OrderDetailsList.SeasonCode|ChimelongStr}}</td>
                            </tr>
                            <tr>
                                <td>贵司订单号</td>
                                <td>{{OrderDetailsList.ThirdOrderNO}}</td>
                                <td>确认号</td>
                                <td>
                                    <span v-for="(i,index) in OrderDetailsList.ConfirmNOs">{{i||'暂无'}}{{i?(OrderDetailsList.ConfirmNOs.length-1-index>0?',':''):''}}</span>
                                </td>
                                <!---->
                            </tr>
                            
                            
                            </tbody>
                        </table>
                    </div>
                    <div class="contact">
                        <div class="title">价格详情</div>
                        <table>
                            <thead>
                            <tr>
                                <td>入住时间</td>
                                <td>间数</td>
                                <td>含早情况</td>
                                <td>币种</td>
                                <td>金额</td>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="item in OrderDetailsList.Details">
                                <td>{{item.CheckIn|delUTC|dateToYMDline}}</td>
                                <td>{{item.RoomCount}}</td>
                                <td>{{item.Breakfast}}</td>
                                <td>{{item.Currency}}</td>
                                <td>{{item.Price}}</td>
                            </tr>
                            <tr>
                                <td>房价小计</td>
                                <td colspan="4">{{OrderDetailsList.Currency}} {{roomTotalAmount}}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="contact" v-if="SurchargesShow">
                        <table>
                            <thead>
                            <tr>
                                <td>附加费用类型</td>
                                <td>时间</td>
                                <td>数量</td>
                                <td>币种</td>
                                <td>单价</td>
                                <td>总价</td>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="item in OrderDetailsList.Surcharges">
                                <td>{{item.Name}}</td>
                                <td>{{item.DateStr}}</td>
                                <td>{{item.Num}}</td>
                                <td>{{item.Currency}}</td>
                                <td>{{item.Price}}</td>
                                <td>{{item.Price*item.Num}}</td>
                            </tr>
                            <tr>
                                <td>附加费用小计</td>
                                <td colspan="5">{{OrderDetailsList.Currency}}{{OrderDetailsList.Surcharge}}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="contact">
                        <div class="title">酒店信息</div>
                        <table>
                            <tbody>
                            <tr>
                                <td>酒店电话</td>
                                <td>{{OrderDetailsList.HotelPhone||''}}</td>
                            </tr>
                            <tr>
                                <td>酒店地址</td>
                                <td>{{OrderDetailsList.HotelAddress||''}}</td>
                            </tr>
                            </tbody>
                        </table>

                    </div>
                    <div class="contact">
                        <div class="title">联络人信息</div>
                        <table>
                            <tbody>
                            <tr>
                                <td>贵司操作员</td>
                                <td>{{OrderDetailsList.Creator}}</td>
                            </tr>
                            <tr>
                                <td>CN跟单人</td>
                                <td>{{OrderDetailsList.Oper}}({{OrderDetailsList.OperPhone}})</td>
                            </tr>
                            </tbody>
                        </table>
                        <div class="seal">
                            <img src="../../assets/img/newydz.png" height="87" width="126"/>
                            <img src="../../assets/img/chapter.png" height="87"/>
                        </div>
                        <div class="print-time">打印时间：{{PrintDate|dateLong}}</div>
                    </div>
                </div>
                <div class="main tips">
                    <div class="contact">
                        <div>
                            郑重提示： 以上优惠价不供网上销售，请告知客人在前台报姓名入住，切勿说出在网上预订，以免出现不能入住的情况！
                            <br>
                            尊敬的客户，您在本社的客户编号为:{{userInfo.CustomerNO}},为了提供更优质快捷的预订服务，在您查询或预订时，请提供您的客户编号，非常感谢您的配合，谢谢！
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Modal v-show="modal.show" :config="modal" @close="modal.show=false" @ok="cancel"></Modal>
    </div>
</template>

<script>
    import Loading from './../../common/cmpnt/Loading/Loading.vue'//缓冲
    import Modal from './../../common/cmpnt/Modal/modal'

    export default {
        name: "order-Details",
        components:{
            Loading,
            Modal
        },
        data: function () {
            return {
                isLoading:false,
                OrderDetailsList:'',
                isPrint:false,
                userInfo: this.dao.get('userInfo'),
                PrintDate:new Date(),
                roomTotalAmount:0,
                RoomPrice:0,
                SurchargesPrice:0,
                SurchargesShow:false,
                qr:'',
                modal:{
                    show:false,
                    config:{}
                },
                cancelToken:'',
                layerShow:false,
                IsCancel:false
            }
        },
        created() {
        },
        mounted() {
            document.title='【'+this.$route.params.orderNO+'】'+'订单详情';
            this.initData();
            this.getQR()
            this.printDate();
        },
        methods: {
            // 是否为可取消订单
            getIsCancel(s1, s2) {
                s1 = new Date(s1);
                s2 = new Date(s2);
                var time = parseInt((s2-s1) / (1000 * 60));
                if(time>=0){
                    this.IsCancel=false
                }else{
                    this.IsCancel=true
                }
            },
            isLayerShow(){
                this.layerShow = !this.layerShow
            },
            routeToCus(){
                window.open('#/orderCustomer/'+this.$route.params.orderNO, '_blank');
                this.$router.push()
            },
            cancel(){
                var that = this;
                that.modal.show = false;
                that.isLoading = true;
                that.postRequest({
                    url: that.Api.cancelOrder,
                    params: that.cancelToken
                }).then(res => {
                    if (res.IsSuccess) {
                        that.initData()
                    } else {
                        that.error({title: '提示', content: res.Msg || '取消失败'});
                        that.initData()
                    }
                });
            },
            getQR(){
                var that = this;
                that.getRequest({
                    url: that.Api.qr+'?orderNO='+that.$route.params.orderNO,
                    params: ''
                }).then(res => {
                    if (res && res.IsSuccess) {
                        that.qr = 'data:image/jpg;base64,'+ res.Result
                    } else {
                        // $state.complete();
                    }
                });
            },
            jSurchargesPrice(list){
                if (list.length==0){
                    return
                }
                var z = 0;
                for (let i = 0; i<list.length; i++){
                    z += parseInt(list[i].Price)*parseInt(list[i].Num)
                }
                this.SurchargesPrice = z
            },
            jRoomPrice(list){
                if (list.length==0){
                    return
                }
                var z = 0;
                for (let i = 0; i < list.length; i++){
                    z += parseInt(list[i].Price)
                }
                this.RoomPrice = z;
            },
            printDate(){
                var that = this;
                var i = setInterval(function () {
                    that.PrintDate = new Date()
                },1000)
            },
            routerBookComfirm(orderNO){
                var that = this;
                var obj={
                    From:1,
                    HotelName:that.OrderDetailsList.HotelName,
                    RoomName:that.OrderDetailsList.RoomName,
                    RPName:'',
                    CheckIn:that.OrderDetailsList.CheckIn,
                    CheckOut:that.OrderDetailsList.CheckOut,
                    RoomCount:that.OrderDetailsList.RoomCount,
                    AdultCount:'',
                    Star:'',
                    HotelAddress:'',
                    HotelPhone:'',
                    AdultPrice:that.OrderDetailsList.TotalAmount,
                    days:that.OrderDetailsList.NightCount,
                    Token:'',
                    CancelPolicy:'',
                    Breakfast:'',
                    Currency:'',
                    Tip:'',
                    Stock:'',
                    MaxPerson:'',
                    Breakfast:'',
                    DailyRates:'',
                    IsAskRoom:'',
                    details:'',
                    room:''
                }
                if(this.OrderDetailsList.OrderType==3){
                    that.$router.push('/ticketBookComfirm?OrderNO='+orderNO)
                }else{
                    var time = Date.parse(new Date())
                    that.dao.set('bookInfo',obj);
                    that.$router.push('/bookComfirm?OrderNO='+orderNO+'&time='+time)
                }

            },
            cancelOrder(token){
                if(!token){
                    return
                }
                var that = this;
                var params = {
                    Token:token
                }
                that.cancelToken = params
                that.modal={
                    show:true,
                    content:'确定要取消订单号:"' + that.$route.params.orderNO + '"的订单吗?',
                    yes:'确定',
                    no:'取消',
                    isComfirm:true
                }
            },
            printBtn(){
                this.isPoint = true;
                document.getElementsByClassName('to-print-btn')[0].style.display = 'none'
                let subOutputRankPrint = document.getElementById('subOutputRank-print1');
                let newContent =subOutputRankPrint.innerHTML;
                let oldContent = document.body.innerHTML;
                document.body.innerHTML = newContent;
                window.print();
                window.location.reload();
                document.body.innerHTML = oldContent;
                document.getElementsByClassName('to-print-btn')[0].style.display = 'block'
                this.isPoint = false;
                return false;
            },
            initData(){
                var that = this;
                that.isLoading = true;
                that.getRequest({
                    url: that.Api.getOrderDetails+'?orderNO='+that.$route.params.orderNO,
                    params: ''
                }).then(res => {
                    that.isLoading = false;
                    if (res && res.IsSuccess) {
                        that.OrderDetailsList = res.Result
                        that.OrderDetailsList.TotalAmount = that.OrderDetailsList.TotalAmount;
                        that.getIsCancel(that.OrderDetailsList.CancelDate,that.OrderDetailsList.BookingOn)
                        // $state.loaded();
                        if(that.OrderDetailsList.Surcharges.length>0){
                            that.SurchargesShow = true
                        }
                        // that.jSurchargesPrice(that.OrderDetailsList.Surcharges);
                        // that.jRoomPrice(that.OrderDetailsList.Details);
                        that.getRoomTotalAmount();//房价小计
                        that.$nextTick(() => {
                            if(localStorage.getItem('lang')=='t'){
                                that.$zh_tran(localStorage.getItem('lang'))
                            }    
                        })
                    } else {
                        // $state.complete();
                    }
                });
            },
            //房价小计
            getRoomTotalAmount(){
                var list=this.OrderDetailsList.Details;
                var total=0;

                list.forEach((item)=>{

                    total+=(item.Price*item.RoomCount)
                })
                this.roomTotalAmount=total;

            }
        }
    }
</script>

<style scoped>
.layer_box{
    background-color: rgba(0, 0, 0, 0.5);
    position: fixed;
    height: 100%;
    width: 100%;
    top: 0;
    z-index: 9999;
}
.layer{
    padding: 20px 40px;
    padding-bottom: 50px;
    width: 360px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    background: linear-gradient(#fcebb5,#fff);
}
.layer .close {
    position: absolute;
    right: 10px;
    top: 10px;
}
.layer .little{
    text-align: center;
    margin-bottom: 10px;
    font-weight: bold;
    /* color: #493b16; */
     background-image: -webkit-linear-gradient(#493b1b,#877648);
    -webkit-text-fill-color:transparent;
    -webkit-background-clip: text;
    
}
.layer .title{
    font-size: 30px;
    text-align: center;
    font-weight: bold;
    /* color: #493b16; */
    background-image: -webkit-linear-gradient(#493b1b,#877648);
    -webkit-text-fill-color:transparent;
    -webkit-background-clip: text;
}
.layer .content{
    line-height: 1.5em;
}
</style>




// WEBPACK FOOTER //
// src/components/order/Details.vue